import { createContext, useContext } from 'react';
import type { AnalyticsContext as WhoopAnalyticsContext } from 'whoop-analytics';

export interface IAnalyticsContext {
  trackPageView: (pageName: string) => void;
  trackAmplitudeEvent: (
    eventName: string,
    properties: WhoopAnalyticsContext,
    pathname?: string,
  ) => void;
}

export const AnalyticsContext = createContext<IAnalyticsContext | null>(null);

export const useAnalytics = (): IAnalyticsContext => {
  const context = useContext(AnalyticsContext);
  if (!context) {
    throw new Error('useAnalytics must be used within an AnalyticsProvider');
  }
  return context;
};
